<div class="zwi-sermon-list-body">
  <div class="zwi-sermon-list-wrapper">
    <div class="zwi-list-container">
      <ng-content></ng-content>
    </div>
  </div>
</div>
